module.exports = __webpack_public_path__ + "assets/img/flamengo3.42cc0fd1.png";